import store from '@/store';
import originalPermissionsHelper from '@/helpers/permissions';
import {Permission, PermissionRestriction, PermissionServiceInterface} from '@/global/types/permission';
import {RouteLocationAsRelative} from 'vue-router';

const service: PermissionServiceInterface = {
    getRouteByPermissionFail: (
        permission: Permission,
        restriction: null | PermissionRestriction = null,
        query: RouteLocationAsRelative['query'] = {}
    ): RouteLocationAsRelative => {

        const permissions = permission
            ? [permission].concat(store.getters['user/permissions/permissions'])
            : store.getters['user/permissions/permissions'];

        // Check restrictions through each user allowed permission
        for (let i: number = 0; i < permissions.length; i++) {

            if (restriction || store.getters['user/permissions/hasRestriction'](permissions[i])) {

                restriction = restriction ?? store.getters['user/permissions/getRestriction'](permissions[i]) as PermissionRestriction;

                if (restriction.isContractor) {

                    store.dispatch("widget/setDisplay", false)

                    return {name: 'errors.403', params: {error: 'not-allowed-contractor'}, query};
                }

                if (restriction.isUserDisabled) {

                    return {name: 'errors.403', params: {error: 'user-disabled'}, query};
                }

                if (restriction.isLoginFailure) {

                    return {name: 'errors.403', params: {error: 'non-employees'}, query};
                }

                if (false === restriction.isUserInSupportedCountry) {

                    return {name: 'errors.403', params: {error: 'eligibility-location'}, query};
                }

                if (false === restriction.isUserTypeAccessAllowed) {

                    return {name: 'errors.403', params: {error: 'not-allowed'}, query};
                }

                if (false === restriction.isUserAllowed) {

                    return {name: 'errors.403', params: {error: 'eligibility'}, query};
                }
            }
        }

        return originalPermissionsHelper.getRouteByPermissionFail(permission, restriction);
    },
    isRestricted(restriction: PermissionRestriction): boolean {

        // Dxc does not have custom logic. So, we can rely on original implementation
        return originalPermissionsHelper.isRestricted(restriction);
    }
}

export default service